"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[571],{

/***/ 90571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10990);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var ImgThirdSection = function(props) {
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ProjectScrubTl = gsap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].timeline */ .ZP.timeline({
            scrollTrigger: {
                trigger: "._caseThirdSectionTrigger",
                start: "`top 100%",
                scrub: 0.8
            }
        });
        ProjectScrubTl.to("._projectImg5", {
            y: -250,
            duration: 0.6
        }, "start");
        var ProjectScrubTl2 = gsap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].timeline */ .ZP.timeline({
            scrollTrigger: {
                trigger: "._caseThirdSectionTrigger",
                start: "`top 100%",
                scrub: 0.8
            }
        });
        ProjectScrubTl2.to("._projectImg6", {
            y: -300,
            duration: 0.6
        }, "start");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pb-[100px] relative _caseThirdSectionTrigger",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "grid grid-cols-2 gap-0 ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative mt-28 mb-20 grow shrink basis-[40%] before:content-[''] before:table after:content-[''] after:table after:clear-both",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "float-left w-[39vw] h-[39.23611vw] relative _caseStudiesTrigger",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                className: "translate-y-[1.23364%]",
                                href: "/case-study/7",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "m-0 relative z-[1] block overflow-hidden bg-transparent after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:right-0 after:h-[70%] case-study-overlay _projectImg5 group",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-0 h-[39.23611vw] bg-black relative overflow-hidden cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                                className: "w-full top-[12%] h-full object-cover group-hover:scale-125 duration-[400ms] ease-in-out",
                                                autoPlay: true,
                                                muted: true,
                                                loop: true,
                                                playsInline: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                                    src: "/videos/widen-hero-mobile.mp4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute bottom-0 left-0 h-full w-full group-hover:bg-[rgba(0,0,0,0.6)] duration-[400ms] flex flex-col justify-end z-10",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "p-[2.14286rem] w-max",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                            className: "text-white font-semibold text-[1.14286rem] md:text-[1.57143rem] lg:text-[1.14286rem] mb-[0.5rem]",
                                                            children: "Winden"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-white font-normal text-[1rem] md:text-[1.42857rem] lg:text-[1rem]",
                                                            children: "UI/UX Design & Dev"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative -right-[60px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative 3xl:top-[17%] top-[15%]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "3xl:h-[39vw] h-[35vw] w-[46.25vw] bg-redblack pt-6 px-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "bgRapChatCaseStudyDesk h-full w-full"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute overflow-hidden group w-[30.55556vw] top-[15%] z-1 ml-[12%] 2xl:ml-[65px] _projectImg6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/case-study/8",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative z-[1] block bg-transparent after:content-[''] after:absolute after:-bottom-10 after:left-0 after:right-0 after:h-[70%] case-study-overlay group cursor-pointer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "relative bg-black",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                                className: "w-full h-[30.55556vw] object-cover group-hover:scale-125 duration-[400ms] ease-in-out",
                                                autoPlay: true,
                                                muted: true,
                                                loop: true,
                                                playsInline: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                                    src: "/videos/onekey-hero-mobile.mp4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute bottom-0 left-0 h-full w-full group-hover:bg-[rgba(0,0,0,0.6)] duration-[400ms] flex flex-col justify-end z-10",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "p-[2.14286rem] w-max",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                            className: "text-white font-semibold text-[1.14286rem] mb-[0.5rem]",
                                                            children: "OneKey"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-white font-normal text-[1rem]",
                                                            children: "UI/UX Design"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ImgThirdSection);


/***/ })

}]);